import { 
  collection, query, where, getDocs 
} from 'firebase/firestore';
import { db } from '../firebase/config';

// Buscar cliente por documento y email - con verificación de pago
export const autenticarCliente = async (documento, email) => {
  console.log('Buscando cliente:', { documento, email });
  
  try {
    const q = query(
      collection(db, 'clientes'),
      where("documento", "==", documento),
      where("email", "==", email),
      where("activo", "==", true)
    );
    
    const querySnapshot = await getDocs(q);
    
    if (!querySnapshot.empty) {
      const clienteDoc = querySnapshot.docs[0];
      const clienteData = clienteDoc.data();
      
      // Verificar si el cliente ha realizado el pago
      if (!clienteData.pagoCompletado) {
        throw new Error('Para acceder a Mi Espacio debes completar el pago del servicio. Contacta a tu asesor para mas informacion.');
      }
      
      const cliente = {
        id: clienteDoc.id,
        ...clienteData,
        fechaRegistro: clienteData.fechaRegistro?.toDate()
      };
      console.log('Cliente autenticado:', cliente.nombre);
      return cliente;
    }
    console.log('Cliente no encontrado');
    return null;
  } catch (error) {
    console.error("Error al autenticar cliente:", error);
    throw error;
  }
};

// Obtener casos de un cliente
export const obtenerCasosCliente = async (clienteId) => {
  console.log('Buscando casos para cliente ID:', clienteId);
  
  try {
    // Obtener TODOS los documentos de la coleccion casos
    const casosRef = collection(db, 'casos');
    const querySnapshot = await getDocs(casosRef);
    
    console.log('Total de casos en Firebase:', querySnapshot.size);
    
    // Filtrar en JavaScript
    const casos = [];
    querySnapshot.forEach(doc => {
      const data = doc.data();
      
      // Verificar si el caso pertenece al cliente
      if (data.clienteId === clienteId && data.activo !== false) {
        casos.push({
          id: doc.id,
          ...data,
          fechaCreacion: data.fechaCreacion?.toDate()
        });
      }
    });
    
    console.log(`${casos.length} casos encontrados para el cliente`);
    return casos;
  } catch (error) {
    console.error("Error al obtener casos:", error);
    throw error;
  }
};

// Obtener verificacion de un caso
export const obtenerVerificacionCliente = async (casoId) => {
  console.log('Buscando verificacion para caso:', casoId);
  
  try {
    const verificacionesRef = collection(db, 'verificaciones');
    const querySnapshot = await getDocs(verificacionesRef);
    
    let verificacionEncontrada = null;
    querySnapshot.forEach(doc => {
      const data = doc.data();
      if (data.casoId === casoId && data.activo !== false) {
        verificacionEncontrada = {
          id: doc.id,
          ...data,
          fechaCreacion: data.fechaCreacion?.toDate()
        };
      }
    });
    
    console.log('Verificacion encontrada:', verificacionEncontrada ? 'Si' : 'No');
    return verificacionEncontrada;
  } catch (error) {
    console.error("Error al obtener verificacion:", error);
    throw error;
  }
};

// Obtener documentos de un caso
export const obtenerDocumentosCliente = async (casoId) => {
  console.log('Buscando documentos para caso:', casoId);
  
  try {
    const documentosRef = collection(db, 'documentos');
    const querySnapshot = await getDocs(documentosRef);
    
    const documentos = [];
    querySnapshot.forEach(doc => {
      const data = doc.data();
      if (data.casoId === casoId && data.activo !== false) {
        documentos.push({
          id: doc.id,
          ...data,
          fechaSubida: data.fechaSubida?.toDate()
        });
      }
    });
    
    console.log(`${documentos.length} documentos encontrados`);
    return documentos;
  } catch (error) {
    console.error("Error al obtener documentos:", error);
    throw error;
  }
};